import reducer from './reducers';
import * as selectors from './selectors';

export default reducer;
export { selectors };
